import { flatten } from 'lodash';

function extractCategoriesAndSubcategories(recommendation) {
  let tagMap = {};
  recommendation.program.subcategories.forEach(subcategory => {
    // Slipping a side effect here to reduce the number of times we loop through
    // these
    subcategory.categories.forEach(category => {
      let displayClass = category.short_name;

      if (!tagMap[displayClass]) {
        tagMap[displayClass] = {
          category: {
            id: category.id,
            schema: 'categories',
          },
          subcategories: [],
        };
      }
    });

    // Add subcategory
    const displayClass = subcategory.categories[0].short_name;
    tagMap[displayClass]['subcategories'].push({
      id: subcategory.id,
      schema: 'subcategories',
    });
  });

  return flatten(
    Object.values(tagMap).map(map => {
      return [map.category].concat(map.subcategories);
    })
  );
}

function extractUniversity(recommendation) {
  return {
    id: recommendation.program.university.id,
    schema: 'universities',
  };
}

function extractProvince(recommendation) {
  return {
    id: recommendation.program.university.province.id,
    schema: 'provinces',
  };
}

function extractCity(recommendation) {
  return {
    id: recommendation.program.university.city.id,
    schema: 'cities',
  };
}

export function extractAllTags(recommendation) {
  return [
    ...extractCategoriesAndSubcategories(recommendation),
    extractCity(recommendation),
    extractProvince(recommendation),
    extractUniversity(recommendation),
  ];
}



// WEBPACK FOOTER //
// ./src/schema/tagHelpers.js